import { TProfileEdgeCrease } from './t-profile-edge-crease';
import { EProfilePaintSide } from './e-profile-paint-side';
import { ProfileLine } from './profile-line';
import { parseEdgeCrease } from './profile-utils';

export interface ProfileV3Data {
    lines: ProfileLine[];
    edgeCreaseSizeMM: number;
    creaseLeft: TProfileEdgeCrease;
    creaseRight: TProfileEdgeCrease;
    paintSide: EProfilePaintSide;
    profileTemplateName?: string;
}

export function profileLoadV3(profile: ProfileV3Data, profileData: string): void {
    if (!profileData) {
        return;
    }

    const data = profileData.split('%');
    profile.paintSide = parseInt(data[1], 10) || EProfilePaintSide.noPaint;
    profile.creaseLeft = parseEdgeCrease(data[2]) || profile.creaseLeft;
    profile.edgeCreaseSizeMM = parseInt(data[3], 10) || profile.edgeCreaseSizeMM;
    profile.creaseRight = parseEdgeCrease(data[4]) || profile.creaseRight;
    profile.profileTemplateName = data[7]?.trim() ? data[7] : undefined;

    const parsedLines = data[6]?.split('|') ?? [];
    const reg = /^([01]?);(\d+);(\d);(\d+);(\d+);([^;]*);([^;]*);([^;]*);([^;]*);([^;]*);([^;]*)$/;

    parsedLines.forEach(lineData => {
        const parts = reg.exec(lineData);
        if (parts) {
            const angle = parseInt(parts[2], 10);
            const direction = 2 * parseInt(parts[3], 10) - 1;

            profile.lines.push({
                restrictTrapeze: Boolean(Number(parts[1])),
                length: parseInt(parts[4], 10),
                length2: parseInt(parts[5], 10),
                alpha: angle * direction,
                direction: direction,
                lengthMin: parseInt(parts[6], 10) || undefined,
                lengthMax: parseInt(parts[7], 10) || undefined,
                length2Min: parseInt(parts[8], 10) || undefined,
                length2Max: parseInt(parts[9], 10) || undefined,
                angleMin: parseInt(parts[10], 10) || undefined,
                angleMax: parseInt(parts[11], 10) || undefined,
            });
        }
    });
}
